// extracted by mini-css-extract-plugin
export var bodyRow = "_gp-d";
export var cardColumns = "_gp-e";
export var ellipsesOverflow = "_gp-2";
export var flatBottomCorners = "_gp-3";
export var flatTopCorners = "_gp-4";
export var headerActionsDropdown = "_gp-f";
export var headerBottomRow = "_gp-c";
export var headerTopRow = "_gp-b";
export var orderDetailsWrapper = "_gp-0";
export var orderInfoContainer = "_gp-1";
export var productDetails = "_gp-9";
export var productImage = "_gp-5";
export var responsiveTable = "_gp-8";
export var shipmentContainer = "_gp-a";
export var tableBottomLeft = "_gp-6";
export var tableBottomRight = "_gp-7";
export var trackingLink = "_gp-g";